import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { accessTokenKey, baseUrl, isPremium } from "../utils/config";

import SingleJob from "./layouts/SingleJob";
import ServicesLayout from "./layouts/Services";
import FAQsLayout from "./layouts/FAQs";
import ContactLayout from "./layouts/Contact";
import PricingTable from "./layouts/PricingTable";
import Loader from "./layouts/Loader";

import carousel2 from "../assets/img/carousel-2.jpg";
import about1 from "../assets/img/about-1.jpg";
import about2 from "../assets/img/about-2.jpg";
import about3 from "../assets/img/about-3.jpg";
import about4 from "../assets/img/about-4.jpg";
import companyLogo from "../assets/img/com-logo-1.jpg";
import testimonial from "../assets/img/testimonial-1.jpg";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function Home() {

    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [locations, setLocations] = useState([]);
    const [fullTime, setFullTime] = useState([]);
    const [partTime, setPartTime] = useState([]);
    const [testimonials, setTestimonials] = useState([
        { name: "Ryan Casey", review: "Adnan was extremely helpful before and after I purchased a project from him. 10/10 seller. I strongly recommend. He responds to your questions straight away. Great service as always and he produces fantastic quality too!", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/62620db70c4813f76bf12593" },
        { name: "Ani Moh", review: "Very good job. I recommend this developer.", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/67480d93e5994cd563360c89" },
        { name: "Jovante Hill", review: "Adnan went above and beyond to assist with getting the files I needed and it is top notch work!", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/66e469de93664cb0047258d9" },
        { name: "Eshan", review: "I recently purchased a web app from Brother Adnan Afzal, and he was incredibly helpful throughout the process. He provided clear communication, tailored the app to my needs, and offered excellent support even after the purchase. I highly recommend brother Adnan. His commitment to customer satisfaction and his technical prowess make him a standout professional in his field. Thank you, Adnan, for your exceptional service and support!", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/665c15b359cc673382f05da5" },
        { name: "Anaelle Brown", review: "Good customer service, although you get the basics, and you will have to work it your way, it does save you a lot of time", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/6641d8e1d49cd8f0266c01b1" },
        { name: "Jay Panchal", review: "The web app we purchased was exactly what we were looking for and it was very feature rich. Thanks to Adnan for prompt response! Keep up the good work!", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/65c840ceec4536c1a4f02d7a" },
        { name: "Eduardo Heredia", review: "The app is awesome, it worths every dollar you pay. Adnan was very supportive during the purchase and the support is superb, always available and kindly.", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/659cfdf813b39fa63335e753" },
        { name: "Selim", review: "I've bought 3 scripts from Adnan, all worked well and he was very helpful at every stage. I'd absolutely recommend with this good prices", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/652864643020af0d885ba1cf" },
        { name: "Joseph Chrzempiec", review: "I bought the Social network script and it is awesome. Adnan helped me to set it up with no problem even walked me though a lot of things I was trying to understand. A very patient person thank you.", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/64bb8fd479d1a742beef9b07" },
        { name: "vonherzenbad", review: "Best communication, very good results, the price is absolutely fine!", source: "TrustPilot", sourceURL: "https://www.trustpilot.com/reviews/64b95142537388cb74b4f81d" },
    ]);
    const [subscribing, setSubscribing] = useState(false);
    const [loading, setLoading] = useState(false);

    async function doSubscribe() {
        setSubscribing(true);

        try {
            const form = document.getElementById("form-subscribe");
            const formData = new FormData(form);

            const response = await axios.post(
                baseUrl + "/api/subscribe",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Subscribe", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubscribing(false);
        }
    }

    async function onInit() {
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("type", "job");
            formData.append("time_zone", Intl.DateTimeFormat().resolvedOptions().timeZone || "");

            const response = await axios.post(
                baseUrl + "/api/fetch-home",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setCategories(response.data.categories);
                setLocations(response.data.locations);
                setFullTime(response.data.full_time);
                setPartTime(response.data.part_time);
            } else {
                // swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        onInit();
    }, []);

    const styles = {
        imgAbout2: {
            width: "85%",
            marginTop: "15%"
        },
        imgAbout3: {
            width: "85%"
        },
        companyLogo: {
            width: "80px",
            height: "80px"
        },
        testimonialUserImg: {
            width: "50px",
            height: "50px"
        },
        bannerBG: {
            background: "rgba(43, 57, 64, .5)"
        },
        categoryContainer: {
            padding: "35px"
        },
        newsletter: {
            maxWidth: "100%"
        }
    };

    return (
        <>
            <div className="container-fluid p-0">
                <div className="owl-carousel header-carousel position-relative">
                    <div className="owl-carousel-item position-relative">
                        <img className="img-fluid" src={ carousel2 } alt="" />
                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center" style={ styles.bannerBG }>
                            <div className="container">
                                <div className="row justify-content-start">
                                    <div className="col-10 col-lg-8">
                                        <h1 className="display-3 text-white animated slideInDown mb-4">Find The Best Job That Fit You</h1>
                                        <p className="fs-5 fw-medium text-white mb-4 pb-2">Discover exciting opportunities at fast-growing companies where your ideas matter. Join teams that value innovation, creativity, and impact. Whether you're a developer, designer, marketer, or dreamer — there's a role that matches your passion.</p>
                                        <Link to="/search" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">Search A Job</Link>
                                        <Link to="/find-talent" className="btn btn-secondary py-md-3 px-md-5 animated slideInRight">Find Talent</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid bg-primary mb-5 wow fadeIn" data-wow-delay="0.1s" style={ styles.categoryContainer }>
                <div className="container">
                    <form onSubmit={ function (event) {
                        event.preventDefault();

                        const form = document.getElementById("form-search");
                        navigate("/search?keyword=" + form.keyword.value + "&category=" + form.category.value + "&location=" + form.location.value);
                    } } id="form-search">
                        <div className="row g-2">
                            <div className="col-md-10">
                                <div className="row g-2">
                                    <div className="col-md-4">
                                        <input type="text" className="form-control border-0" name="keyword" placeholder="Keyword" />
                                    </div>
                                    <div className="col-md-4">
                                        <select className="form-select border-0" name="category">
                                            <option value="">Category</option>

                                            { categories.map(function (category, index) {
                                                return (
                                                    <option key={ `category-${ index }` }
                                                        value={ category.category }>{ category.category }</option>
                                                );
                                            }) }
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <select className="form-select border-0" name="location">
                                            <option value="">Location</option>
                                            
                                            { locations.map(function (location, index) {
                                                return (
                                                    <option key={ `location-${ index }` }
                                                        value={ location }>{ location }</option>
                                                );
                                            }) }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <button type="submit" className="btn btn-dark border-0 w-100">Search</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Explore By Category</h1>

                        { loading && (
                            <div className="row mb-5">
                                <div className="col-md-12 text-center">
                                    <Loader />
                                </div>
                            </div>
                        ) }

                        <div className="row g-4">
                            { categories.map(function (category, index) {
                                return (
                                    <div key={ `category-${ index }` }
                                        className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                                        <Link className="cat-item rounded p-4" to={ `/search?category=${ category.category }` }>
                                            <i className={ `fa fa-3x ${ category.icon } text-primary mb-4` }></i>
                                            <h6 className="mb-3">{ category.category }</h6>
                                            <p className="mb-0">{ category.vacancies } Vacancy</p>
                                        </Link>
                                    </div>
                                );
                            }) }
                        </div>

                        <h1 className="text-center mt-5 mb-5 wow fadeInUp" data-wow-delay="0.1s">Our Services</h1>
                        <ServicesLayout />

                        <div className="row mt-5 mb-5 g-5 align-items-center">
                            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
                                <div className="row g-0 about-bg rounded overflow-hidden">
                                    <div className="col-6 text-start">
                                        <img className="img-fluid w-100" src={ about1 } />
                                    </div>
                                    <div className="col-6 text-start">
                                        <img className="img-fluid" src={ about2 } style={ styles.imgAbout2 } />
                                    </div>
                                    <div className="col-6 text-end">
                                        <img className="img-fluid" src={ about3 } style={ styles.imgAbout3 } />
                                    </div>
                                    <div className="col-6 text-end">
                                        <img className="img-fluid w-100" src={ about4 } />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                                <h1 className="mb-4">We Help To Get The Best Job And Find A Talent</h1>
                                <p className="mb-4">Whether you're searching for your dream job or the perfect candidate, we bridge the gap between opportunity and potential. Our platform is designed to connect skilled professionals with growing businesses.</p>
                                <p><i className="fa fa-check text-primary me-3"></i><b>Find Jobs That Match Your Skills</b> – Browse thousands of openings tailored to your career goals.</p>
                                <p><i className="fa fa-check text-primary me-3"></i><b>Hire Top-Quality Candidates</b> – Access a pool of vetted professionals ready to make an impact.</p>
                                <p><i className="fa fa-check text-primary me-3"></i><b>Fast & Easy Process</b> – Save time with our simple job posting and application system.</p>
                                {/*<a className="btn btn-primary py-3 px-5 mt-3" href="">Read More</a>*/}
                            </div>
                        </div>

                        <h1 className="text-center mt-5 mb-3 wow fadeInUp" data-wow-delay="0.1s">Job Listing</h1>
                        <div className="tab-class text-center mb-5 wow fadeInUp" data-wow-delay="0.3s">
                            <ul className="nav nav-pills d-inline-flex justify-content-center border-bottom mb-5">
                                <li className="nav-item">
                                    <a className="d-flex align-items-center text-start mx-3 pb-3 active" data-bs-toggle="pill" href="#tab-1">
                                        <h6 className="mt-n1 mb-0">Full Time</h6>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="d-flex align-items-center text-start mx-3 me-0 pb-3" data-bs-toggle="pill" href="#tab-2">
                                        <h6 className="mt-n1 mb-0">Part Time</h6>
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div id="tab-1" className="tab-pane fade show p-0 active">
                                    { fullTime.map(function (j, index) {
                                        return (
                                            <SingleJob job={ j }
                                                key={ `job-${ j.id }` } />
                                        );
                                    }) }

                                    <Link className="btn btn-primary py-3 px-5" to="/search?nature=full_time">Browse More Jobs</Link>
                                </div>

                                <div id="tab-2" className="tab-pane fade show p-0">
                                    { partTime.map(function (j, index) {
                                        return (
                                            <SingleJob job={ j }
                                                key={ `job-${ j.id }` } />
                                        );
                                    }) }

                                    <Link className="btn btn-primary py-3 px-5" to="/search?nature=part_time">Browse More Jobs</Link>
                                </div>
                            </div>
                        </div>

                        <h1 className="text-center mb-5">Our Clients Say!!!</h1>

                        <Slider dots={true} infinite={true} speed={1000} slidesToShow={1} slidesToScroll={1} autoplay={true} arrows={true}>
                            { testimonials.map(function (testimonial, index) {
                                return (
                                    <div className="testimonial-item bg-light rounded p-4"
                                        key={ `testimonial-${ index }` }>
                                        <i className="fa fa-quote-left fa-2x text-primary mb-3"></i>
                                        <p>{ testimonial.review }</p>
                                        
                                        <div className="d-flex align-items-center">
                                            {/*<img className="img-fluid flex-shrink-0 rounded" src={ testimonial } style={ styles.testimonialUserImg } />*/}
                                            
                                            <div className="1ps-3">
                                                <h5 className="mb-1">{ testimonial.name }</h5>
                                                <small>
                                                    { testimonial.sourceURL ? (
                                                        <a href={ testimonial.sourceURL }
                                                            target="_blank">{ testimonial.source }</a>
                                                    ) : (
                                                        <span>{ testimonial.source }</span>
                                                    ) }
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) }
                        </Slider>

                        <h1 className="text-center mt-5 mb-3">FAQs</h1>
                        <FAQsLayout />

                        <div className="row mt-5 mb-5">
                            <div className="offset-md-3 col-md-6">
                                <h1 className="text-center mb-3">Newsletter</h1>
                                <p className="mb-4 text-center">Subscribe to get updates, tips, and exclusive content straight to your inbox.</p>

                                <div className="position-relative mx-auto" style={ styles.newsletter }>
                                    <form onSubmit={ function (event) {
                                        event.preventDefault();
                                        doSubscribe();
                                    } } id="form-subscribe">
                                        <input className="form-control bg-transparent w-100 py-3 ps-4 pe-5" type="email"
                                            placeholder="Your email"
                                            name="email" />
                                        <button type="submit" className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
                                            disabled={ subscribing }>Subscribe</button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        { !isPremium && (
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="text-center mb-5">Pricing</h1>
                                    <PricingTable />
                                </div>
                            </div>
                        ) }
                    </div>
                </div>
            </div>

            <ContactLayout />
        </>
    );
}

export default Home;